// src/translation/TranslateText.js
import React, { useContext, useState, useEffect } from 'react';
import translateText from './TranslateService';
import { LanguageContext } from '../LanguageContext';

const TranslateText = ({ text }) => {
  const { language } = useContext(LanguageContext);
  const [translatedText, setTranslatedText] = useState(text);

  useEffect(() => {
    const translate = async () => {
      if (language !== 'en') {
        const result = await translateText(text, language);
        setTranslatedText(result);
      } else {
        setTranslatedText(text);
      }
    };

    translate();
  }, [text, language]);

  return <>{translatedText}</>;
};

export default TranslateText;
